import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: (withTray, isTimeLineView) => ({
    paddingHorizontal: isTimeLineView ? 0 : 16,
    paddingTop: 20,
    paddingBottom: isTimeLineView ? 0 : withTray ? 90 : 15,
  }),
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  sectionHeader: isTimeLineView => ({
    marginHorizontal: isTimeLineView ? 16 : 0,
  }),
  headerSubTitle: theme => ({
    ...Fonts.type.bold,
    fontSize: 25,
    lineHeight: 31.2,
    color: theme.colors.headerColor,
    marginTop: 33.7,
  }),
  button: {
    marginTop: 13,
  },
  headerDescription: theme => ({
    fontSize: 16.6,
    color: theme.colors.subtitle,
    marginVertical: 17,
  }),
  noAddonsText: {
    fontSize: 17,
    alignSelf: 'center',
    width: '85%',
    textAlign: 'center',
    fontFamily: Fonts.type.VodafoneLt,
    lineHeight: 22,
    marginTop: 23,
  },
  headerTitle: theme => ({
    fontWeight: 'bold',
    fontSize: 25,
    lineHeight: 31,
    color: theme.colors.headerColor,
    marginTop: 34.2,
  }),
  errorContainer: {
    paddingHorizontal: 16.6,
  },
  errorIconStyle: {
    marginTop: 55.8,
  },
  filterBar: {
    marginTop: 15,
    marginLeft: -15,
  },
});
